define('drops/grid/grid',[
    'jquery',
    'lq/drop',
    'lq/style',
    'underscore',
    'lq/util',
    'drops/grid/gridPager',
    'lq/html'
], function ($, Drop, Style, _, util, GridPager, html) {
    'use strict';

    var defaults = {
        data: {
            showNavigationAtTop: false,
            showNavigationAtBottom: true,
            pageSize: 10
        }
    };

    function Grid(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.columns = _.map(this.data.columns, function (column) {
            return util.convertListOfKeyValuesToObject(column);
        });
        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$element
            .addClass('boxToBorderSize');

        this.$wrapper = $('<div />')
            .css({
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                whiteSpace: 'pre-wrap',
                overflow: 'auto'
            })
            .appendTo(this.$element);

        this.page = 0;

        this.renderStyles();

        this.update();
    }

    Drop.extend(Grid, Drop);

    Grid.typeName = 'Grid';

    Grid.prototype.preRender = function () {
        this.piping.visibility.apply(this);

        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function(data) {
                self.update(data);
            },
            function(data) {
                self.decorateDataSourceData(data);
            });

        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
    	this.applyPosition();
    };

    Grid.prototype.renderStyles = function () {
    	var self = this;
    	// TODO need to fix this in backend
    	self.data.styles = self.data.styleId;
    	Style.renderStyles(self, 'gridstyle-');
    };

    Grid.prototype.decorateDataSourceData = function (data) {
        data.page = this.page;
        data.pageSize = this.data.pageSize;
        if (this.sortParameters) {
            data.sortParameters = this.sortParameters;
        }
    };

    Grid.prototype.dispatchQuery = function () {
        var self = this;
        this.piping.queryDispatcher.dispatch(
            this.data.dataSource,
            function (data) { self.update(data, self); },
            function (data) { self.decorateDataSourceData(data); });
    };

    Grid.prototype.groupColumnsFromLeftToRight = function (allRows, indexOfFirstRow, indexOfLastRow, allGroupedColumns, indexOfThisGroup) {
        if (indexOfThisGroup > allGroupedColumns.length - 1) {
            return;
        }

        var outputKey = allGroupedColumns[indexOfThisGroup].output;
        var indexOfCurrentRow = indexOfLastRow;
        while (indexOfCurrentRow >= indexOfFirstRow) {
            if (indexOfCurrentRow > indexOfFirstRow && allRows[indexOfCurrentRow][outputKey] === allRows[indexOfCurrentRow - 1][outputKey]) {
                allRows[indexOfCurrentRow][outputKey] = null;
                indexOfCurrentRow -= 1;
            } else {
                this.groupColumnsFromLeftToRight(allRows, indexOfCurrentRow, indexOfLastRow, allGroupedColumns, indexOfThisGroup + 1);
                indexOfCurrentRow -= 1;
                indexOfLastRow = indexOfCurrentRow;
            }
        }
    };

    Grid.prototype.update = function (data) {
        var self = this;
        self.selectedRowIndex = null;

        if (data == undefined) {
            data = {};
            data.totalResults = 0;
            data.results = [];
        }
        
        var displayData = _.map(data.results, function (row) {
            return $.extend({}, row);
        });
        var columnsToGroupOn = _.filter(self.data.columns, function (column) {
            return column.group;
        });
        self.groupColumnsFromLeftToRight(displayData, 0, displayData.length - 1, columnsToGroupOn, 0);

        self.data.totalResults = data.totalResults;
        self.$wrapper.empty();

        if (this.data.showNavigationAtTop)
            new GridPager(this, this.$wrapper).update(this.page, this.data.pageSize, this.data.totalResults);

        var $table = $('<table class="grid">')
            .css({
                tableLayout: self.data.autoSizeColumns ? null : 'fixed',
                width: self.data.autoSizeColumns ? '100%' : self.calculateColumnWidthSum(),
                textAlign: 'left',
                borderSpacing: 0,
                lineHeight: 1
            });

        if (!self.data.autoSizeColumns) {
            var $colgroup = $('<colgroup>').appendTo($table);
            _.each(self.data.columns, function (column) {
                $colgroup.append('<col style="width:' + column.width + 'px;"/>');
            });
        }

        //Create header row
        var $thead = $('<thead>').appendTo($table);
        var $headerRow = $('<tr>').appendTo($thead);

        _.each(self.data.columns, function (column) {
            var $th = $('<th>')
                .css('overflow', self.data.autoSizeColumns ? null : 'hidden')
                .appendTo($headerRow);
            $('<a href="#">')
                .text(column.alias)
                .on('click', function () { self.sortByColumn(column); })
                .appendTo($th);
        });

        $table.appendTo(self.$wrapper);

        var clickedEvent = this.getEventDataFor('clicked');
        var selectedEvent = this.getEventDataFor('selected');
        var deselectedEvent = this.getEventDataFor('deselected');

        //create value rows
        $.each(displayData, function (rowKey, row) {
            var $row = $('<tr/>');
            
            _.each(self.data.columns, function (column) {
                var colType = data.outputs[column.output];
                var value = self.formatter.convertFromLicquidFormat(colType, row[column.output]);

                if (row[column.output] === null) {
                    value = '&nbsp;';
                }
                
                var $cell = $('<td/>')
                    .html(html.sanitize(value))
                    .appendTo($row);

                if (!self.data.autoSizeColumns) {
                    $cell.css({ overflow: 'hidden' });
                }
            });

            if (clickedEvent.enabled || deselectedEvent.enabled || selectedEvent.enabled) {
                $row
                    .addClass('clickablerow')
                    .on('click', function () {
                        if (deselectedEvent.enabled || selectedEvent.enabled) {
                            var isSelectedRow = $row.hasClass('selectedrow');
                            $row.parent().children().removeClass('selectedrow');
                            if (!isSelectedRow)
                                $row.addClass('selectedrow');
                        }
                        self.triggerEventIfEnabled('clicked', row[self.data.eventArg]);
                        if (self.selectedRowIndex === rowKey) {
                            self.triggerEventIfEnabled('deselected', data.results[self.selectedRowIndex][self.data.eventArg]);
                            self.selectedRowIndex = null;
                        } else if (rowKey !== self.selectedRowIndex) {
                            self.triggerEventIfEnabled('selected', row[self.data.eventArg]);
                            self.selectedRowIndex = rowKey;
                        }
                    });
            }

            $row.appendTo($table);
        });

        if (this.data.showNavigationAtBottom)
            new GridPager(this, this.$wrapper).update(this.page, this.data.pageSize, this.data.totalResults);
    };
    
    Grid.prototype.first = function () {
        this.page = 0;
        this.dispatchQuery();
    };

    Grid.prototype.previous = function () {
        if (this.page > 0) {
            this.page--;
            this.dispatchQuery();
        }
    };

    Grid.prototype.next = function () {
        if (this.page < Math.floor(this.data.totalResults / this.data.pageSize)) {
            this.page++;
            this.dispatchQuery();
        }
    };

    Grid.prototype.last = function () {
        this.page = Math.floor(this.data.totalResults / this.data.pageSize - 0.01);
        this.dispatchQuery();
    };
    
    Grid.prototype.calculateColumnWidthSum = function () {
        var self = this;
        return _.reduce(self.data.columns, function (sum, col) {
            return sum + col.width;
        }, 0);
    };

    Grid.prototype.sortByColumn = function (column) {
        var self = this;
        var descending = self.sortParameters && self.sortParameters[0].output === column.output
            && !self.sortParameters[0].descending;

        self.sortParameters = [{ output: column.output, descending: descending }];
        self.dispatchQuery();
    };

    return Grid;
});

